var _rect, _rect2, _mask, _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 32,
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SAMPLE MOCKUP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All Panel Layout without Edge"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-18 -15)",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Header_CP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header.tsx"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_386_25808",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18 -15H1902V49H-18V-15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-18 -15H1902V49H-18V-15Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1902 48H-18V50H1902V48Z",
    fill: "#D1D1D1",
    mask: "url(#path-1-inside-1_386_25808)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "headerTitle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approvals / Launch icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_25808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M8.87781 4.43878C10.0039 5.00183 11.3294 5.00183 12.4555 4.43878L20.7143 0.309389C21.1024 0.115335 21.5607 0.122277 21.9427 0.327997L27.7384 3.44874C28.6895 3.96087 28.6687 5.33219 27.7025 5.81527L21.3333 8.99987L27.7384 12.4487C28.6895 12.9609 28.6687 14.3322 27.7025 14.8153L21.3333 17.9999L27.7384 21.4487C28.6895 21.9609 28.6687 23.3322 27.7025 23.8153L12.4555 31.4388C11.3294 32.0018 10.0039 32.0018 8.87781 31.4388L1.4741 27.7369C0.570676 27.2852 2.54313e-06 26.3618 2.54313e-06 25.3518V22.3108L1.27157e-06 22.3119L0 4.31463C0 2.33228 2.08617 1.04295 3.85924 1.92949L8.87781 4.43878Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_25808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M27.7384 21.4489C28.6895 21.961 28.6687 23.3323 27.7025 23.8154L12.4555 31.4389C11.3294 32.002 10.0039 32.002 8.87781 31.4389L1.4741 27.737C0.570675 27.2853 1.90735e-06 26.362 1.90735e-06 25.3519V21.236C1.90735e-06 19.7493 1.56463 18.7823 2.89443 19.4472L8.87782 22.4389C10.0039 23.0019 11.3294 23.0019 12.4555 22.4389L21.3333 18L27.7384 21.4489Z",
    fill: "url(#paint0_linear_386_25808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HardShadow",
    opacity: 0.5,
    d: "M12.4555 13.9389C11.3294 14.502 10.0039 14.502 8.87781 13.9389L3.70951 11.3548C1.97346 10.4867 -0.0787489 11.705 -0.148025 13.6447L-0.5 23.5L-0.385028 22.3503C-0.199177 20.4918 1.79038 19.3952 3.46098 20.2305L8.87781 22.9389C10.0039 23.502 11.3294 23.502 12.4555 22.9389L27.7025 15.3154C28.6687 14.8323 28.6895 13.461 27.7384 12.9489L21.3333 9.5L12.4555 13.9389Z",
    fill: "black",
    stroke: "black",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M12.4555 13.4389C11.3294 14.002 10.0039 14.002 8.87781 13.4389L3.85924 10.9296C2.08617 10.0431 1.27157e-06 11.3324 1.27157e-06 13.3148V23L1.0973e-06 22.3148C5.93162e-07 20.3324 2.08617 19.0431 3.85924 19.9296L8.87781 22.4389C10.0039 23.002 11.3294 23.002 12.4555 22.4389L27.7025 14.8154C28.6687 14.3323 28.6895 12.961 27.7384 12.4489L21.3333 9L12.4555 13.4389Z",
    fill: "url(#paint1_linear_386_25808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HardShadow_2",
    opacity: 0.5,
    d: "M12.4555 4.93891C11.3294 5.50196 10.0039 5.50196 8.87782 4.93891L3.71304 2.35652C1.9761 1.48805 -0.0769422 2.708 -0.144579 4.64878L-0.499512 14.8333L-0.363266 13.3786C-0.188427 11.5119 1.80738 10.4037 3.48435 11.2422L8.87782 13.9389C10.0039 14.502 11.3294 14.502 12.4555 13.9389L27.7025 6.3154C28.6687 5.83232 28.6895 4.461 27.7384 3.94887L21.9427 0.828127C21.5607 0.622408 21.1024 0.615466 20.7143 0.809519L12.4555 4.93891Z",
    fill: "black",
    stroke: "black",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    d: "M12.4555 4.43891C11.3294 5.00196 10.0039 5.00196 8.87781 4.43891L3.85924 1.92962C2.08617 1.04308 0 2.3324 0 4.31475V14.3333V13.3148C0 11.3324 2.08617 10.0431 3.85924 10.9296L8.87781 13.4389C10.0039 14.002 11.3294 14.002 12.4555 13.4389L27.7025 5.8154C28.6687 5.33232 28.6895 3.961 27.7384 3.44887L21.9427 0.328127C21.5607 0.122408 21.1024 0.115466 20.7143 0.309519L12.4555 4.43891Z",
    fill: "url(#paint2_linear_386_25808)"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_386_25808",
    x1: 4.00001,
    y1: 31.8333,
    x2: 28.3333,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B4476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8231E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_386_25808",
    x1: -9.66667,
    y1: 28.6667,
    x2: 28.6667,
    y2: 9.33333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA69FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_386_25808",
    x1: -7.66667,
    y1: 18,
    x2: 29.8333,
    y2: 1.66666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3889DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/MainLogo.75fc59853ddb7898a7ecad70f89be8fe.svg";
export { ForwardRef as ReactComponent };